import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/lib/data";

export default function ServicesGrid({ limit }) {
    const items = limit ? services.slice(0, limit) : services;
    return (
        <section data-testid="services-grid" className="border-t border-line">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20 md:py-32">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
                    <div>
                        <p className="eyebrow mb-6">What we install, organize and support</p>
                        <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-2xl">
                            Nine service scopes. One coordinated team.
                        </h2>
                    </div>
                    <Link to="/services" className="inline-flex items-center gap-2 text-sm text-ink link-underline">See all nine services <ArrowUpRight className="w-4 h-4" /></Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-line">
                    {items.map((s, i) => (
                        <motion.div
                            key={s.slug}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                            className="group border-r border-b border-line"
                        >
                            <Link to={`/services/${s.slug}`} className="block p-8 md:p-10 h-full flex flex-col">
                                <div className="flex items-center justify-between mb-10">
                                    <span className="font-mono text-xs text-muted tracking-widest">{s.number} /</span>
                                    <span className="inline-flex items-center justify-center w-9 h-9 border border-line group-hover:bg-ink group-hover:text-bg group-hover:border-ink transition-colors duration-300">
                                        <ArrowUpRight className="w-4 h-4" />
                                    </span>
                                </div>
                                <h3 className="font-display text-2xl md:text-[28px] leading-tight tracking-tight text-ink mb-3">{s.title}</h3>
                                <p className="text-sm text-muted leading-relaxed mb-6 flex-1">{s.short}</p>
                                <div className="mt-auto text-xs font-mono uppercase tracking-widest text-muted group-hover:text-gold transition-colors duration-300">Read scope →</div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
